import React from 'react';
import { useSelector } from 'react-redux';
import { fetchXmlHeaders } from '../../actions/settings/xmlHeaders';
import XMLHeaderSettingsPage from '../../components/body/settings/XMLHeaderSettingsPage';
import { useAppDispatch } from '../../store/ReduxStore';
import { AsyncDispatch } from '../../../types/global';
import { ApplicationState } from '../../reducers';

const SettingsXMLHeadersContainer: React.FC = () => {
  const dispatch: AsyncDispatch = useAppDispatch();

  const brandId = useSelector((state: ApplicationState) => state.parent.brands.selectedBrandId);

  React.useEffect(() => {
    dispatch(fetchXmlHeaders(brandId));
  }, [brandId, dispatch]);

  return (
    <div className="bg-white h-full ">
      <XMLHeaderSettingsPage />
    </div>
  );
};

export default SettingsXMLHeadersContainer;
